import { useEffect, useState } from 'react';
import { useRerenderOnInterval } from './useRerenderOnInterval';

export type UseLogarithmicApproachProgressArgs = {
    approximateTimeSeconds: number;
    isDisabled?: boolean;
};

export type UseLogarithmicApproachProgressReturnValue = {
    progress: number;
};

function logarithmicApproach(timeInSeconds: number, approximateTime: number) {
    const approach = (x: number) => (x * Math.log(x + 1)) / (1 + x * Math.log(x + 1));
    // x = 15 is aprox 95% of the approach.
    const xValueOfApproach = 15;
    // we want to hit 95% at 30 seconds.
    const timeScaled = (timeInSeconds / approximateTime) * xValueOfApproach;
    const returnValue = Math.min(approach(timeScaled) * 100, 99);
    return returnValue;
}

export const useLogarithmicApproachProgress = ({
    approximateTimeSeconds,
    isDisabled,
}: UseLogarithmicApproachProgressArgs): UseLogarithmicApproachProgressReturnValue => {
    const [startTime, setStartTime] = useState<Date | null>(null);
    useEffect(() => {
        setStartTime(isDisabled ? null : new Date());
    }, [isDisabled]);
    useRerenderOnInterval({ interval: 40, isDisabled });
    const progress = startTime
        ? logarithmicApproach(Math.min((Date.now() - startTime.getTime()) / 1000, 60), approximateTimeSeconds)
        : 0;

    return {
        progress,
    };
};
